/* eslint-disable @typescript-eslint/no-var-requires */

export enum Host {
  CTL_AUTHENTICATOR_SERVER = 'CTL_AUTHENTICATOR_SERVER',
  CTL_DATA_SERVER = 'CTL_DATA_SERVER',
  CTL_IMAGE_SERVER = 'CTL_IMAGE_SERVER',
}

export type Hosts = Record<Host, string>;

const defaultHosts: Hosts = require(
  `./${process.env.REACT_APP_DEPLOYMENT_PHASE}.ts`
).default;

// Override with environment variables if they exist
export const HOSTS: Hosts = {
  CTL_AUTHENTICATOR_SERVER:
    process.env.REACT_APP_CTL_AUTHENTICATOR_SERVER ||
    defaultHosts.CTL_AUTHENTICATOR_SERVER,
  CTL_DATA_SERVER:
    process.env.REACT_APP_CTL_DATA_SERVER || defaultHosts.CTL_DATA_SERVER,
  CTL_IMAGE_SERVER:
    process.env.REACT_APP_CTL_IMAGE_SERVER || defaultHosts.CTL_IMAGE_SERVER,
};
